import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CompanyBase } from 'app/shared/models/company-base.model';
import { CompanyService } from 'app/shared/services/company.service';
import { Observable, Subject } from 'rxjs';

@Component({
  selector: 'app-company-selection-list',
  templateUrl: './company-selection-list.component.html',
  styleUrls: ['./company-selection-list.component.scss']
})

export class CompanySelectionListComponent implements OnInit {
  @Input() active: boolean = true;
  @Input() label: string;
  @Input() hideLabel: boolean = false;
  @Input() selectedCompany: CompanyBase;
  @Input() selectCompanyText: string;
  @Output() companyChangedEvent: EventEmitter<CompanyBase> = new EventEmitter<CompanyBase>();

  companyList$: Observable<CompanyBase[]>;
  companyListLoading = false;
  companyListinput$ = new Subject<string>();

  constructor(private companyService: CompanyService) {
  }

  ngOnInit() {
    this.loadCompanyList();
  }

  private loadCompanyList() {
    this.companyList$ = this.companyService.getList<CompanyBase>("/company/list");
  }

  selectedCompanyChanged(company: CompanyBase) {
    this.companyChangedEvent.emit(company);
  }
}
